<style>
    .plus-order-hj{
        margin-left: 20px;
    }

</style>
<template lang="html">
    <el-row>
    <table-template
            :hasSearch="false"
            :queryParams="searchInfo"
            actionUrl="lcwpOrder/findOrderAdminList.action"
            ref="listTemplate">

        <template slot="search">
            <el-row >
                <el-form :inline="true">
                  <el-form-item>
                    <el-select  @change="$refs.listTemplate.search()" :clearable="true" placeholder="核销状态"
                                v-model="searchInfo.declareStatus">
                      <el-option :value="1" label="待核销"></el-option>
                      <el-option :value="2" label="已核销"></el-option>
                      <el-option :value="3" label="已退款"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select  @change="$refs.listTemplate.search()" :clearable="true" placeholder="支付状态"
                               v-model="searchInfo.payStatus">
                      <el-option :value="1" label="待支付"></el-option>
                      <el-option :value="2" label="支付成功"></el-option>
                      <el-option :value="3" label="支付失败"></el-option>
                      <el-option :value="4" label="支付关闭"></el-option>
                      <el-option :value="5" label="转入退款"></el-option>
                      <el-option :value="6" label="取消支付"></el-option>
                      <el-option :value="7" label="支付中"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item  v-belong-to-admin>
                    <channel-select  @change="onChannelChange" placeholder="请输入渠道来源"></channel-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="商家名称/订单号/用户账号" v-model="searchInfo.keyword"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-date-picker

                        @change="onDateTimeRangeChange"
                        end-placeholder="创建结束日期"
                        range-separator="至"
                        start-placeholder="创建开始日期"
                        type="datetimerange"
                        v-model="searchInfo.createTimes">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="$refs.listTemplate.search()" type="primary">搜索</el-button>

                  </el-form-item>
                  <el-form-item> <el-button @click="exportPlusOrder()" style="" type="danger">导出</el-button></el-form-item>
                  <el-form-item v-if="businessId">
                    <el-button @click="toReleaseProduct()" style="margin-right:20px;" type="primary" >
                      发布产品
                    </el-button>
                  </el-form-item>
                </el-form>

            </el-row>

        </template>

        <template  slot="item">
            <el-table-column label="订单号" prop="orderNumber"></el-table-column>
            <el-table-column label="下订人">
                <template scope="scope">
                    {{scope.row.phone}} - {{scope.row.nickname}}
                </template>
            </el-table-column>
            <el-table-column label="商家名" prop="businessName">
            </el-table-column>
            <el-table-column label="金额">
                <template scope="scope">
                    {{scope.row.money/100}} 元
                </template>
            </el-table-column>
            <el-table-column label="支付状态">
                <template scope="scope">
                    <p v-bind:style="{color:payStatusColor(scope.row.payStatus)}">{{scope.row.payStatus |
                        payStatusFilter}} </p>
                </template>
            </el-table-column>

            <el-table-column label="退款状态">
                <template scope="scope">
                    {{scope.row.refundStatus | refundStatusFilter}}<br>
                    <span>{{scope.row.refundNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="核销状态">
                <template scope="scope">
                    {{scope.row.declareStatus | declareStatusFilter}}
                    <a @click="showInvoice(scope.row)" v-if="scope.row.exchangeImage">[购车发票]</a>
                </template>
            </el-table-column>

            <el-table-column label="支付时间" width="200">
                <template scope="scope">
                    {{scope.row.payTime | dateTimeFormat}}
                </template>

            </el-table-column>

            <el-table-column label="创建时间" width="200">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>

            </el-table-column>

            <el-table-column
                    label="操作" width="150px">
                <template scope="scope">
                    <el-dropdown trigger="click">
                        <el-button class="el-dropdown-link" size="mini" type="primary">
                            更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item @click.native.prevent="showOrderData(scope.row.id)" >查看商品详情</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>

        </template>

    </table-template>

    <el-dialog :visible.sync="dialogOrderFormVisible" label-width="80px" title="查看商品详情"
               width="50%">

        <el-table :data="orderDatas" class="basic-margin" style="width: 100%">
            <el-table-column label="商品名称" width="250px">
                <template scope="scope">
                    {{scope.row.goodsName}}
                </template>
            </el-table-column>
            <el-table-column label="购买数量">
                <template scope="scope">
                    {{scope.row.goodsCount}}
                </template>
            </el-table-column>
            <el-table-column label="商品单价(元)">
                <template scope="scope">
                    {{scope.row.totalPrice/100}}
                </template>
            </el-table-column>
            <el-table-column label="待核销码">
                <template scope="scope">
                    {{scope.row.declares}}
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
        </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'goods-list',
  extends: BasicPager,
  data: function () {
    return {
      dialogOrderFormVisible: false,
      orderDatas: null,
      dialogOrderForm: {
        orderId: null
      },
      searchInfo: {
        status: null,
        type: '新车',
        keyword: null,
        pageNum: 1,
        pageSize: 20
      },
      imageUrl: Config.imageUrl
    }
  },
  filters: {
    declareStatusFilter: function (value) {
      // 1-待核销2-已核销3-已退款
      let str = ''
      switch (value) {
        case 1:
          str = '待核销'
          break
        case 2:
          str = '已核销'
          break
        case 3:
          str = '已退款'
          break
        default:
          str = '无'
      }
      return str
    },

    refundStatusFilter: function (value) {
      // 退款状态：1-退款成功2-退款关闭3退款处理中4退款异常5未申请（默认值）6超时订单
      let str = ''
      switch (value) {
        case 1:
          str = '退款成功'
          break
        case 2:
          str = '退款关闭'
          break
        case 3:
          str = '退款处理中'
          break
        case 4:
          str = '退款异常'
          break
        case 5:
          str = '未申请'
          break
        case 6:
          str = '超时订单'
          break
        default:
          str = '无'
      }
      return str
    },
    payStatusFilter: function (value) {
      // 1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        case 6:
          str = '取消支付'
          break
        case 7:
          str = '支付中'
          break
        default:
          str = '无'
      }
      return str
    }
  },
  components: {
    TableTemplate,
    channelSelect
  },
  props: {
    type: {
      type: String,
      default: null
    },
    businessId: {
      type: Number,
      default: null
    }
  },
  created: function () {
    this.searchInfo.type = this.type
    if (this.businessId) {
      this.searchInfo.businessId = this.businessId
    }
    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath === 'channel') {
      this.searchInfo.channelId = loginInfo.id
    }
  },
  methods: {
    showOrderData: function (id) {
      this.dialogOrderForm.orderId = id
      this.loadOrderData()
      this.dialogOrderFormVisible = true
    },
    loadOrderData: function () {
      let _this = this
      let params = {
        orderId: this.dialogOrderForm.orderId
      }

      let listener = {
        success: function (dataInfo) {
          _this.orderDatas = dataInfo.datas
        }
      }
      let action = 'lcwpOrder/findOrderGoodsAdminList.action'
      BasicModel.get(this, action, params, listener)
    },
    payStatusColor: function (payStatus) {
      let color = ''
      switch (payStatus) {
        case 1:
          color = '#909399'
          break
        case 2:
          color = '#67C23A'
          break
        case 3:
          color = '#F56C6C'
          break
        case 4:
          color = '#F56C6C'
          break
        case 5:
          color = '#F56C6C'
          break
        case 6:
          color = '#F56C6C'
          break
        default:
      }
      return color
    },
    onChannelChange: function (channelId) {
      this.searchInfo.channelId = channelId
      this.$refs.listTemplate.search()
    },
    toReleaseProduct: function () {
      this.$router.push({ name: '添加plus商品', params: { businessId: this.businessId } })
    },
    onDateTimeRangeChange: function (time) {
      let createTime = this.searchInfo.createTimes
      if (createTime && createTime[0]) {
        this.searchInfo.startTime = createTime[0].getTime()
        this.searchInfo.endTime = createTime[1].getTime()
      } else {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
      }

      this.$refs.listTemplate.search()
    },
    exportPlusOrder: function () {
      let _this = this
      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      if (this.searchInfo.channelId) {
        id = this.searchInfo.channelId
      }
      let dataStr = ''

      if (loginPath === 'channel') {
        dataStr = '&channelId=' + id
      }

      if (this.searchInfo.declareStatus) {
        dataStr += '&declareStatus=' + this.searchInfo.declareStatus
      }
      if (this.searchInfo.payStatus) {
        dataStr += '&payStatus=' + this.searchInfo.payStatus
      }
      if (this.searchInfo.startTime) {
        dataStr += '&startTime=' + this.searchInfo.startTime
      }

      if (this.searchInfo.endTime) {
        dataStr += '&endTime=' + this.searchInfo.endTime
      }

      if (this.searchInfo.keyword) {
        dataStr += '&keyword=' + this.searchInfo.keyword
      }

      window.location.href = Config.baseUrl + '/lcwpOrder/exportPlusOrder.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }
  }
}
</script>

<style lang="css" scoped>
</style>
